import { type Organisation } from '../models/organisation';

export function generateCsrSubjData({ org }: { org: Organisation }) {
  if (!org) return '';

  const { name = '', country_code = '', city = '' } = org;
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  const state = regionNames.of(country_code);

  return `-subj /O='${name}'/C='${country_code}'/ST='${state}'/L='${city}'/`;
}
